import React from "react";
import styles from "./Grid.module.scss";

export const GridContainer: React.FC = props => <div {...props} className={styles.container}/>

export const GridRow: React.FC = props => <div {...props} className={styles.row}/>

export const GridCol: React.FC = props => <div {...props} className={styles.col}/>

export const GridColLg: React.FC = props => <div {...props} className={styles.colLg}/>